<template>
  <div class="pb-5">
    <div class="my-breadcrumb row justify-content-center breadcrumb-brown m-0">
      <div class="col-9">
        <div class="breadcrumb-title align-items-center d-flex">
          <div class="breadcrumb-inactive">
            <font-awesome-icon :icon="['far', 'palette']" size="lg" fixed-width class="d-inline" />
            <span class="pl-2">Colores</span>
          </div>
        </div>
      </div>
      <div class="col-lg-1 col-3 text-right">
        <button class="my-button my-button-green my-button-sm" @click="goToNewColor">Nuevo</button>
      </div>
    </div>
    <div class="custom-tabs row justify-content-center m-0">
      <div class="col-lg-10 text-right">
        <ul>
          <li><a href="/designs" class="dash-nav-link">Diseños</a></li>
          <li><a href="/motors" class="dash-nav-link">Motores</a></li>
          <li><a href="/app/prod/colores" class="dash-nav-link active">Colores</a></li>
        </ul>
      </div>
    </div>
    <section class="table-directory colors-directory mt-4">
      <div class="row justify-content-center m-0">
        <div class="col-lg-10">
          <b-row class="mb-4" align-v="end">
            <b-col cols="12" md="6" lg="5">
              <div class="d-flex align-items-end">
                <b-form-group label="Buscador general" label-class="text-muted mb-1 font-weight-bold m-0" class="mb-0 flex-grow-1">
                  <b-input-group class="shadow-sm rounded">
                    <b-input
                      ref="searchInput"
                      v-model="searchTerm"
                      placeholder="Buscar por nombre, RAL o Hex"
                      class="border-secondary-light"
                      @keyup.enter="focusSearch"
                    />
                    <b-input-group-append class="mb-0">
                      <b-button variant="outline-secondary" @click="focusSearch">
                        <font-awesome-icon :icon="['fas', 'search']" fixed-width />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-form-group class="ml-2 mb-0">
                  <b-button variant="outline-secondary" class="shadow-sm" @click="resetSearch" title="Limpiar filtros">
                    <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                  </b-button>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="7" class="d-flex justify-content-end mt-3 mt-md-0">
              <b-form-group label="Acabado" label-class="text-muted mb-1 font-weight-bold m-0" class="mr-3" style="width: 200px;">
                <b-form-select v-model="selectedFinish" :options="finishOptions" class="border-secondary-light text-muted shadow-sm rounded w-100"></b-form-select>
              </b-form-group>
              <b-form-group label="Estado" label-class="text-muted mb-1 font-weight-bold m-0" style="width: 260px;">
                <b-form-select v-model="selectedStatus" :options="statusOptions" class="border-secondary-light text-muted shadow-sm rounded w-100"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="loading" class="text-center text-info my-5">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Cargando colores...</strong>
          </div>
          <div v-else>
            <div v-if="filteredColors.length === 0">
              <div class="table-title">Sin resultados</div>
                <table class="table table-bordered table-hover fs-13 m-0 bg-white">
                  <thead class="thead-light">
                  <tr class="text-center">
                    <th style="width: 80px;">Muestra</th>
                    <th>Nombre</th>
                    <th>Acabado</th>
                    <th>RAL</th>
                    <th>Hex</th>
                    <th style="width: 80px;" title="Cantidad de muestras"><font-awesome-icon :icon="['far', 'image']" size="lg" /></th>
                    <th>Estado</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td colspan="7" class="text-center text-secondary py-5 ">
                      <font-awesome-icon :icon="['fas', 'search']" size="2x" class="mb-2 text-muted" /><br/>
                      <span class="fs-16">No hay resultados</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            <div v-else v-for="table in tablesGrouped" :key="table.title">
            <div class="mb-5" v-if="table.items.length > 0">
              <div class="table-title">{{ table.title }}</div>
                <table class="table table-bordered table-hover fs-13 m-0 bg-white">
                  <thead class="thead-light">
                    <tr class="text-center">
                    <th style="width: 80px;">Muestra</th>
                    <th>Nombre</th>
                    <th>Acabado</th>
                    <th>RAL</th>
                    <th>Hex</th>
                    <th style="width: 80px;" title="Cantidad de muestras"><font-awesome-icon :icon="['far', 'image']" size="lg" /></th>
                    <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in table.items" :key="item.id || index" class="clickable-row text-center" @click="goToRailsShow(item.id)">
                      <td class="align-middle">
                        <div class="row justify-content-center">
                        <div v-if="hasValidHex(item.hex_code)" class="color-square-sm" :style="{ backgroundColor: formatHex(item.hex_code) }"></div>
                          <div v-else-if="failedImages[item.id]" class="color-square-sm bg-light d-flex align-items-center justify-content-center text-secondary small font-weight-bold">
                            N/A
                          </div>
                          <b-img
                            v-else
                            :src="getJaspeImagePath(item)"
                            fluid
                            class="color-sample-hex-sm"
                            @error="onImageError(item)"
                          />
                        </div>
                      </td>
                      <td class="align-middle font-weight-bold text-dark">{{ item.name }}</td>
                      <td class="align-middle text-secondary">{{ item.tipo_acabado || 'N/A' }}</td>
                      <td class="align-middle text-secondary">
                        {{ item.ral_code || 'N/A' }}
                        <b-badge v-if="item.ral_code" variant="light" class="border cursor-pointer ml-1 text-muted hover-copy" @click.stop="copyText(item.ral_code, 'Código RAL')">Copiar</b-badge>
                      </td>
                      <td class="align-middle text-secondary">
                        {{ item.hex_code || 'N/A' }}
                        <b-badge v-if="item.hex_code" variant="light" class="border cursor-pointer ml-1 text-muted hover-copy" @click.stop="copyText(item.hex_code, 'Código Hex')">Copiar</b-badge>
                      </td>
                      <td class="align-middle font-weight-bold text-secondary">{{ item.samples_count || 0 }}</td>
                      <td :class="['align-middle', item.status === 'Activo' ? 'text-success' : 'text-danger']">
                        {{ item.status }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
name: 'ColorIndex',
data() {
  return {
    colors: [],
    loading: true,
    searchTerm: '',
    selectedFinish: null,
    selectedStatus: null,
    failedImages: JSON.parse(localStorage.getItem('color_image_errors') || '{}'),
    finishOptions: [
      { value: null, text: '-- Todos --' },
      { value: 'Satinado', text: 'Satinado' },
      { value: 'Mate', text: 'Mate' }
    ],
    statusOptions: [
      { value: null, text: 'Todos (Activos / Inactivos)' },
      { value: 'Activo', text: 'Solo Activos' },
      { value: 'Inactivo', text: 'Solo Inactivos' }
    ]
  };
},
computed: {
  filteredColors() {
    if (!this.colors) return []
    return this.colors.filter(color => {
      const term = this.searchTerm.toLowerCase()
      const name = (color.name || '').toLowerCase()
      const ral = (color.ral_code || '').toLowerCase()
      const hex = (color.hex_code || '').toLowerCase()
      const matchSearch = name.includes(term) || ral.includes(term) || hex.includes(term)
      const matchStatus = this.selectedStatus ? color.status === this.selectedStatus : true
      const matchFinish = this.selectedFinish ? color.tipo_acabado === this.selectedFinish : true
      return matchSearch && matchStatus && matchFinish
    })
  },
  tablesGrouped() {
    const filteredColors = this.filteredColors
    return [
      {
        title: 'Liso',
        items: filteredColors.filter(c => c.tipo_color === 'Liso' || (!c.tipo_color && !(c.name || '').toLowerCase().includes('jaspe')))
      },
      {
        title: 'Jaspe',
        items: filteredColors.filter(c => c.tipo_color === 'Jaspe' || (!c.tipo_color && (c.name || '').toLowerCase().includes('jaspe')))
      },
      {
        title: 'Especial',
        items: filteredColors.filter(c => c.tipo_color === 'Especial')
      },
      {
        title: 'Puerta',
        items: filteredColors.filter(c => c.tipo_color === 'Puerta')
      }
    ]
  }
},
mounted() {
  this.fetchColors()
},
methods: {
  fetchColors() {
    this.loading = true
    this.$http.get('/api/production/colors')
      .then(response => {
        this.colors = (Array.isArray(response.data) ? response.data : (response.data.colors || [])).map(item => ({
        ...item
        }))
      }).catch(error => {
        console.error(error)
      }).finally(() => {
        this.loading = false
      })
  },
  resetSearch() {
    this.searchTerm = '';
    this.selectedFinish = null;
    this.selectedStatus = null;
  },
  focusSearch() {
    if (this.$refs.searchInput) {
      this.$refs.searchInput.focus()
    }
  },
  goToRailsShow(id) {
    window.location.href = `/colors/${id}`
  },
  goToNewColor() {
    window.location.href = `/colors/new`
  },
  hasValidHex(val) {
    if (!val || val === 'N/A' || val.trim() === '') return false
    return /^[0-9A-Fa-f]{3,6}$/.test(val.replace('#', ''))
  },
  getJaspeImagePath(item) {
    if (!item || !item.name) return ''
    const firstWord = item.name.trim().toUpperCase().split(' ')[0]
    return `/images/colors/${firstWord}.png`
  },
  onImageError(item) {
    if (item && item.id) {
      this.$set(this.failedImages, item.id, true)
      localStorage.setItem('color_image_errors', JSON.stringify(this.failedImages))
    }
  },
  copyText(text, label) {
    if (!text) return
    navigator.clipboard.writeText(text).then(() => {
      this.$bvToast.toast(`${text}`, {
      title: `${label} copiado exitosamente`,
      variant: 'success',
      solid: true,
      toaster: 'b-toaster-bottom-right',
      autoHideDelay: 2500
      })
    })
  },
  formatHex(val) {
    if (!val) return 'transparent'
    return val.toString().startsWith('#') ? val : '#' + val
  }
}
};
</script>

<style scoped>
  .custom-tabs ul li a.dash-nav-link.active {
    color: #8c5332 !important;
    border-bottom: 2px solid #8c5332 !important;
  }
  .custom-tabs ul li a.dash-nav-link {
    color: #6c757d;
    text-decoration: none;
    padding-bottom: 5px;
  }
  .custom-tabs ul li a.dash-nav-link:hover {
    color: #8c5332;
  }
  .clickable-row {
    cursor: pointer;
    transition: background-color 0.15s;
  }
  .clickable-row:hover {
    background-color: rgba(0, 0, 0, 0.03) !important;
  }
  .color-square-sm {
    width: 45px;
    height: 45px;
    border-radius: 6px;
    border: 1px solid rgba(0,0,0,0.15);
    display: block;
  }
  .color-sample-hex-sm {
    width: 45px;
    height: 45px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid rgba(0,0,0,0.15);
    display: block;
  }
  .hover-copy {
    transition: all 0.2s ease;
  }
  .hover-copy:hover {
    background-color: #6c757d !important;
    color: white !important;
  }
</style>